import store from '../store/store'

class Utils {
  productName (product) {
    if (store.state.contractorManagement.settings.dynamics && product.item.mfg_name === 'Dynamic') {
      return product.name.replace('Dynamic', store.state.contractorManagement.settings.dynamic_mfg_name)
    } else {
      return product.name
    }
  }

  productMfgName (mfgName) {
    if (store.state.contractorManagement.settings.dynamics && mfgName === 'Dynamic') {
      return store.state.contractorManagement.settings.dynamic_mfg_name
    } else {
      return mfgName
    }
  }

  itemName (item) {
    if (store.state.contractorManagement.settings.dynamics && item.mfg_name === 'Dynamic') {
      return item.name.replace('Dynamic', store.state.contractorManagement.settings.dynamic_mfg_name)
    } else {
      return item.name
    }
  }

  itemDescription (item) {
    if (store.state.contractorManagement.settings.dynamics && item.mfg_name === 'Dynamic') {
      return item.description.replace('Dynamic', store.state.contractorManagement.settings.dynamic_mfg_name)
    } else {
      return item.description
    }
  }

  formatCardNumber (number, type) {
    const raw = String(number || '').replace(/\D/g, '')

    // Max lengths by brand (use broader maxima for visa/discover to allow 19 digits)
    const maxLenByType = {
      amex: 15,
      visa: 16,
      discover: 16,
      mastercard: 16
    }
    const maxLen = maxLenByType[type] || 16
    const digits = raw.slice(0, maxLen)

    // Grouping
    if (type === 'amex') {
      const p1 = digits.slice(0, 4)
      const p2 = digits.slice(4, 10)
      const p3 = digits.slice(10, 15)
      return [p1, p2, p3].filter(Boolean).join(' ')
    }

    // Default: groups of 4
    const parts = []
    for (let i = 0; i < digits.length; i += 4) {
      parts.push(digits.slice(i, i + 4))
    }
    return parts.join(' ')
  }

  getCardTypeIcon (brand) {
    let icon = ''
    brand = brand || 'unknown'
    const cardBrandToIcon = {
      'Visa': 'fab fa-cc-visa',
      'visa': 'fab fa-cc-visa',
      'Mastercard': 'fab fa-cc-mastercard',
      'mastercard': 'fab fa-cc-mastercard',
      'Amex': 'fab fa-cc-amex',
      'amex': 'fab fa-cc-amex',
      'Discover': 'fab fa-cc-discover',
      'discover': 'fab fa-cc-discover',
      'unknown': 'fa fa-credit-card'
    }
    if (cardBrandToIcon[brand]) {
      icon = cardBrandToIcon[brand]
    }

    return icon
  }

  isPOBox (address) {
    if (!address) return false

    const normalized = address.replace(/\./g, '').toUpperCase()

    return (
      /\bPO\s*BOX\b/.test(normalized) ||
      /\bPOST\s*OFFICE\s*BOX\b/.test(normalized) ||
      /\bPOBOX\b/.test(normalized)
    )
  }
}

export default new Utils()
